// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k76Xn","delete":"styles_delete__1muOa","update":"styles_update__1h0KM","add":"styles_add__3dsKa"};